import { StoreContext } from '../../../lib/store';
import * as React from 'react';
import { useContext } from 'react';
import style from './styles.scss';
import { ArrowButton } from 'common/components/arrow-button';

export function Component() {
  const defaultPosition: number = 4;

  const store = useContext(StoreContext);
  const { formatConfig, creativeStore } = store;
  const { closeBtn, useBtnAutoMargin } = formatConfig;

  const creativeLeftShift =
    useBtnAutoMargin && creativeStore.creativeSize?.left != null
      ? creativeStore.creativeSize.left
      : 0;
  const arrowBtnPosition: React.CSSProperties = {
    left:
      !closeBtn || closeBtn?.position === 'left'
        ? 'auto'
        : defaultPosition + creativeLeftShift,
    right:
      closeBtn?.position === 'right'
        ? 'auto'
        : defaultPosition + creativeLeftShift // use the same left position because your creative is aligned in the middle of the container
  };

  return (
    <div className={style.arrowBtnPosition} style={arrowBtnPosition}>
      <ArrowButton />
    </div>
  );
}
